(function () {
    'use strict';

    angular
        .module('app.trendyolIntegration')
        .controller('TrendyolMatchCategoryListController', TrendyolMatchCategoryListController);

    TrendyolMatchCategoryListController.$inject = ['$location', 'TrendyolIntegrationService', 'NgTableParams', '$uibModal'];

    function TrendyolMatchCategoryListController($location, TrendyolIntegrationService, NgTableParams, $uibModal) {
        /* jshint validthis:true */
        var vm = this;
        vm.settings = globalSettings;
        activate();
        function activate() {
            vm.firstLoad = true;
            vm.tableParams = new NgTableParams(
                angular.extend({ page: 1, count: 10 }, $location.search()),
                {
                    getData: function (params) {
                        if (!vm.firstLoad) {
                            $location.search(params.url());
                        }
                        vm.firstLoad = false;
                        var filterData2 = params.filter();
                        var filterData = {};
                        filterData.PageIndex = params.page(),
                            filterData.PageSize = params.count(),
                            filterData.SortProperty = Object.keys(params.sorting())[0],
                            filterData.SortType = params.sorting()[Object.keys(params.sorting())[0]];
                        var keys = Object.keys(filterData2);
                        for (var i = 0; i < keys.length; i++) {
                            filterData[keys[i]] = filterData2[keys[i]];
                        }
                        return TrendyolIntegrationService.getAllMatchCategory(filterData).then(function (data) {
                            params.total(data.FilteredCount);
                            return data.Data;
                        });

                    }
                });

            vm.fields = TrendyolIntegrationService.getMatchCategoryFields();
        }

        vm.delete = function (entity) {
            if (confirm("Silmek istediğinize emin misiniz?")) {
                TrendyolIntegrationService.delMatchCategory(entity).then(function (data) {
                    vm.tableParams.reload();
                });
            }
        };

        vm.transferCategory = function (entity) {

            vm.loading = true;
            TrendyolIntegrationService.transferCategory(entity).then(function (data) {
                vm.openModal(data);

                vm.loading = false;
            });
        };

        vm.transferCategoryControl = function (entity) {

            vm.loading = true;
            TrendyolIntegrationService.transferCategoryControl(entity).then(function (data) {
                vm.openModal(data);

                vm.loading = false;
            });
        };

        vm.transferAllCategory = function () {
            vm.loading = true;
            TrendyolIntegrationService.transferAllCategory().then(function (data) {
                vm.openModal(data);
                vm.loading = false;
            });
        };


        // Modal

        vm.modalTitle = "Trendyol Error";
        vm.modalInstance = null;
        vm.openModal = function (data) {
            vm.modalInstance = $uibModal.open({
                templateUrl: 'ModalContent.html',
                controller: 'ModalController',
                controllerAs: 'vm',
                resolve: {
                    items: function () {
                        return {
                            data: data
                        };
                    }
                }
            });
        }



    }
    angular
        .module('app.excel')
        .controller('ModalController', ModalController);

    ModalController.$inject = ['$scope', '$stateParams', '$filter', '$location', 'logger', 'ExcelService', '$uibModal', '$uibModalStack', '$uibModalInstance', 'items'];

    function ModalController($scope, $stateParams, $filter, $location, logger, ExcelService, $uibModal, $uibModalStack, $uibModalInstance, items) {

        var vm = this;
        vm.content = items;
        activate();
        function activate() {
            vm.data = vm.content.data;
        }
    }
})();